<script>
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimKontrolTutarlari from "@/models/StrBirimKontrolTutarlari";
export default {
  mixins: [Api, Sabit, StrBirimKontrolTutarlari],
  props: ["Id", "AddEdit", "TanimId"],
  data() {
    return {
      FormData: {},
      DusumYapilacakMi:false,
      DusumYapilacakBirim:null,
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
    };
  },
 
  components: {
    Loader,
    forminput,
    formcombobox,
    formcheckbox,
    BirimSecimi
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      if (this.AddEdit == "Add") {
        this.FormData.TanimId = this.TanimId;
      }
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        if(!this.DusumYapilacakMi){

          if (this.AddEdit == "Add") {
                      this.Post("StrBirimKontrolTutarlari", this.FormData).then((res) => {
                        if (res) {
                          this.$emit("TableUpdate");
                        }
                      }); 
                      this.$bvModal.hide("StrBirimKontrolTutarlari");
                    } else {
                      this.Update("StrBirimKontrolTutarlari", this.FormData).then((res) => {
                        if (res) {
                          this.$emit("TableUpdate");
                          this.$emit("Update", this.FormData);
                          this.$bvModal.hide("StrBirimKontrolTutarlari");
                        }
                      });
                    }


        } else {

      
        let Filter = "&Donem=" + this.FormData.Donem+
        "&BirimId=" + this.DusumYapilacakBirim+
        "&HarcamaTipId=" + this.FormData.HarcamaTipId ;

        let birim_tutari=0;
      
              this.ActionsFilterGet({
                Service: "StrBirimKontrolTutarlari",
                Page: this.Page,
                Filter: Filter,
              }).then((res) => { 

                for(var i=0;i<res.Data.length;i++){
                  birim_tutari=birim_tutari+res.Data[i].Tutar;

                }


                  if(birim_tutari>=this.FormData.Tutar)
                  {    
                  
                    if (this.AddEdit == "Add") {
                      this.Post("StrBirimKontrolTutarlari", this.FormData).then((res) => {
                        if (res) {
                          this.$emit("TableUpdate");
                              if(this.DusumYapilacakMi){
                                var FormData = this.FormData
                                FormData.BirimId = this.DusumYapilacakBirim
                                FormData.Tutar = -(this.FormData.Tutar) 
                                this.Post("StrBirimKontrolTutarlari", FormData, false).then((res) => {
                                  if (res) {
                                    this.$emit("TableUpdate");
                                  }
                                });  
                              }
                        }
                      }); 
                      this.$bvModal.hide("StrBirimKontrolTutarlari");
                    } else {
                      this.Update("StrBirimKontrolTutarlari", this.FormData).then((res) => {
                        if (res) {
                          this.$emit("TableUpdate");
                          this.$emit("Update", this.FormData);
                          this.$bvModal.hide("StrBirimKontrolTutarlari");
                        }
                      });
                    }

                  }else{

                    this.$toast.error("Düşüm yapılacak birim matrahı yetersiz!"+" \nKullanılabilir Tutar: "+birim_tutari);
                  }
                });


      }
    }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrBirimKontrolTutarlari"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrBirimKontrolTutarlari.AddEdit.FormTitleEdit')
          : $t('StrBirimKontrolTutarlari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >

      <Form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Donem"
              :Value="FormData.Donem"
              :v="$v.FormData.Donem"
              @input="FormData.Donem = $event"
            />
          </div>

          <div class="col-md-6">


                  <BirimSecimi
                  :title="FormDataType.BirimId.FieldTitle"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="FormData.BirimId"
                    :labels_lg="'3'"  
                    :v="$v.FormData.BirimId"
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.BirimId=$event"
                  />
        
  

          </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.HarcamaTipId"
              :Value="FormData.HarcamaTipId"
              :v="$v.FormData.HarcamaTipId"
              @input="FormData.HarcamaTipId = $event"
            />
          </div>

          <div class="col-md-6">
             <forminput
              :step="0.01"
              :FormDataType="FormDataType.Tutar"
              :Value="FormData.Tutar"
              :v="$v.FormData.Tutar"
              @input="FormData.Tutar = $event"
            />
          </div>
        </div> 
         <div class="row"  >
          <div class="col-md-6">
            <formcheckbox
              :FormDataType="{
              FieldName:'Aktif',
              Field:'checkbox',
              FieldTitle:this.$t('StrBirimKontrolTutarlari.AddEdit.DusumYapilacakMi')
              }"
              :Value="DusumYapilacakMi"
              :v="$v.DusumYapilacakMi"
              @input="DusumYapilacakMi = $event"
            /> 
        </div> 
          <div class="col-md-6">


            <b-form-group
             v-if="DusumYapilacakMi"
          class="mb-2"
          id="donemler"
          label="Düşüm Yapılacak Birim"
          label-for="text"
        >
                  <BirimSecimi            
                    :title_position="'mb-3'"
                    :selected="DusumYapilacakBirim"
                    :labels_lg="'3'"  
                    :v="$v.DusumYapilacakBirim"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="DusumYapilacakBirim=$event"
                  />
              </b-form-group>

            </div> </div> 
        <button class="btn btn-primary" type="submit">
          {{ $t("StrBirimKontrolTutarlari.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
